import { render, staticRenderFns } from "./Yoga.vue?vue&type=template&id=086bc0ea&lang=pug&"
import script from "./Yoga.vue?vue&type=script&lang=ts&"
export * from "./Yoga.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports